/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1AccessIdPhotoQueryResponse,
  GetApiV1AccessIdPhotoPathParams,
  GetApiV1AccessIdPhoto401,
  GetApiV1AccessIdPhoto404,
  GetApiV1AccessIdPhoto500,
} from "../../types/personRegisterController/GetApiV1AccessIdPhoto.ts";

function getGetApiV1AccessIdPhotoUrl(
  id: GetApiV1AccessIdPhotoPathParams["id"],
) {
  const res = { method: "GET", url: `/api/v1/access/${id}/photo` as const };
  return res;
}

/**
 * @description Retorna a foto de perfil da pessoa.
 * @summary Obter foto de perfil
 * {@link /api/v1/access/:id/photo}
 */
export async function getApiV1AccessIdPhoto(
  id: GetApiV1AccessIdPhotoPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1AccessIdPhotoQueryResponse,
    ResponseErrorConfig<
      | GetApiV1AccessIdPhoto401
      | GetApiV1AccessIdPhoto404
      | GetApiV1AccessIdPhoto500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1AccessIdPhotoUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
